(function(){
  /* Pagina coșului: +/− și câmpul de cantitate actualizează coșul prin AJAX (/cart/change.js)
     și re-randează secțiunea pe loc (prețuri, subtotal, livrare gratuită) fără reîncărcarea paginii.
     Cantitatea nu poate depăși stocul (data-max); la maxim „+" e inactiv (gri). */
  var sec=null, sid=null, timers={};
  function clampVal(v,mx){ v=parseInt(v,10); if(isNaN(v)||v<0) v=0; if(!isNaN(mx) && mx>0 && v>mx) v=mx; return v; }
  function maxOf(inp){ return parseInt(inp.getAttribute("data-max"),10); }
  function keyOf(inp){ var m=(inp.getAttribute("name")||"").match(/^updates\[(.+)\]$/); return m?m[1]:null; }
  function syncPlus(inp){
    var wrap=inp.closest(".qty"); if(!wrap) return;
    var plus=wrap.querySelector('.amc-qbtn[data-d="1"]'), mx=maxOf(inp), v=parseInt(inp.value,10)||0;
    if(plus) plus.disabled = !isNaN(mx) && mx>0 && v>=mx;
  }
  function setCount(n){ document.querySelectorAll(".cart-count").forEach(function(el){ el.setAttribute("data-n",n); el.textContent=n; }); }
  function rerender(){
    if(!sec || !sid) { location.reload(); return; }
    return fetch(location.pathname+"?section_id="+encodeURIComponent(sid)).then(function(r){ return r.text(); }).then(function(html){
      var d=new DOMParser().parseFromString(html,"text/html");
      var fresh=d.getElementById("shopify-section-"+sid) || d.body;
      sec.innerHTML=fresh.innerHTML;
      bind();
    });
  }
  function push(inp){
    var key=keyOf(inp); if(!key) return;
    var qty=clampVal(inp.value, maxOf(inp)); inp.value=qty; syncPlus(inp);
    clearTimeout(timers[key]);
    /* mică așteptare ca mai multe click-uri rapide să plece ca o singură cerere */
    timers[key]=setTimeout(function(){
      fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({id:key,quantity:qty})})
        .then(function(r){ return r.json(); })
        .then(function(c){ if(c && typeof c.item_count==="number") setCount(c.item_count); return rerender(); })
        .catch(function(){ rerender(); });
    },350);
  }
  function bind(){
    var form=document.getElementById("amcCart"); if(!form) return;
    sec=form.closest('[id^="shopify-section-"]'); sid=sec ? sec.id.replace("shopify-section-","") : null;
    var inputs=[].slice.call(form.querySelectorAll('input[name^="updates["]'));
    inputs.forEach(function(inp){
      syncPlus(inp);
      inp.addEventListener("change",function(){ push(inp); });
      inp.addEventListener("keydown",function(e){ if(e.key==="Enter"){ e.preventDefault(); push(inp); } });
    });
    form.querySelectorAll(".amc-qbtn").forEach(function(b){
      b.addEventListener("click",function(){
        var inp=b.closest(".qty").querySelector("input");
        var v=parseInt(inp.value,10)||0, mx=maxOf(inp);
        if(b.getAttribute("data-d")==="1"){ if(!isNaN(mx) && mx>0 && v>=mx) return; v=v+1; }
        else v=Math.max(0,v-1);
        inp.value=v; push(inp);
      });
    });
    /* la „Finalizează comanda" trimitem cantitățile deja limitate la stoc */
    form.addEventListener("submit",function(){ inputs.forEach(function(inp){ inp.value=clampVal(inp.value, maxOf(inp)); }); });
    /* coș ajuns peste stoc înainte de limită -> îl corectăm o dată */
    inputs.forEach(function(inp){ var mx=maxOf(inp), v=parseInt(inp.value,10)||0; if(!isNaN(mx) && mx>0 && v>mx){ inp.value=mx; push(inp); } });
  }
  bind();
})();
